import { useEffect } from "react";

const useOutsideClick3 = (ref1, ref2, ref3, ref4, callback) => {
  const handleClick = e => {
    if (ref1.current && !ref1.current.contains(e.target) && 
    ref2.current && !ref2.current.contains(e.target) && 
    ref3.current && !ref3.current.contains(e.target) &&
    ref4.current && !ref4.current.contains(e.target)) {
      callback();
    }
  }; 

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export default useOutsideClick3;